<div class="widget" [ngClass]="{'loader-shown': loading, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-accounts" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element counter-loading"></div>
      <div class="loader-element counter-loading"></div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <span class="custom-icon" aria-hidden="true">
      <span class="icon material-icons-outlined">pie_chart</span>
    </span>
    <span class="title">Accounts</span>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">

    <div *ngIf="!noData" class="counters">
      <div>
        <span class="count">{{ accountsCreated }}</span>
        <span class="count-text">Accounts created</span>
      </div>
      <div>
        <span class="count">{{ accountsAccepted }}</span>
        <span class="count-text">T&C accepted</span>
      </div>
    </div>

    <div *ngIf="noData" class="custom-message">
      <span class="icon material-icons no-data">hourglass_empty</span>
      <p>No responses to display yet.</p>
      <small></small>
    </div>
    
  </div>
</div>